import uuid from 'uuid';

function get_id() {
  return uuid();
}

export default get_id;
